
import { useSelector } from 'redux/store';

// ----------------------------------------------------------------------
const useRegexPassword = () => {
    const { allSetting } = useSelector((state) => state.all);
    const length = allSetting?.MDP?.MDP_TAILLE_MIN?.valeur;  
    return `^$|(?=.*[a-zà-ÿ])(?=.*[A-ZÀ-Ÿ])(?=.*[0-9])(?=.{${length},})`;
};


export default useRegexPassword;
